import { render, staticRenderFns } from "./orderFollow.vue?vue&type=template&id=f7d58738&scoped=true"
import script from "./orderFollow.vue?vue&type=script&lang=js"
export * from "./orderFollow.vue?vue&type=script&lang=js"
import style0 from "./orderFollow.vue?vue&type=style&index=0&id=f7d58738&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7d58738",
  null
  
)

export default component.exports